'use client';

import { motion } from 'framer-motion';
import { TileCell } from './TileCell';

export type TileState =
  | 'default'
  | 'correct'
  | 'present'
  | 'absent';

export interface Tile {
  letter: string | null;
  state: TileState;
  locked?: boolean;
}

export interface WordleGridProps {
  grid: Tile[][];
  cursor: { row: number; col: number };
  shakeRow: number | null;
  dateKey?: string; // Pour déclencher l'animation lors du changement de date
}

export function WordleGrid({
  grid,
  cursor,
  shakeRow,
  dateKey,
}: WordleGridProps) {
  return (
    <div
      className="pointer-events-none mx-auto flex origin-top items-center justify-center"
      style={
        {
          // Taille de tuile = remplit le conteneur parent (container query :
          // cqw/cqh = largeur/hauteur de la zone grille flex-1), bornée par la
          // largeur (5 tuiles + 4 gaps de 8px) ET la hauteur (6 tuiles + 5 gaps),
          // plafonnée à 4rem (64px). La zone grille étant l'espace restant entre
          // l'en-tête et le clavier, les tuiles sont aussi grandes que possible
          // sans jamais chevaucher le clavier. Fallback 4rem si cqw/cqh non
          // supportés (Safari < 16).
          '--tile-size':
            'min((100cqw - 2rem) / 5, (100cqh - 2.5rem) / 6, 4rem)',
        } as React.CSSProperties
      }
    >
      <div className="flex flex-col gap-[8px]">
        {grid.map((row, rowIndex) => (
          <motion.div
            key={rowIndex}
            className="grid grid-cols-5 gap-[8px]"
            animate={
              shakeRow === rowIndex
                ? { x: [-10, 10, -8, 8, -4, 4, 0] }
                : { x: 0 }
            }
            transition={{ duration: 0.4 }}
          >
            {row.map((tile, colIndex) => (
              <TileCell
                key={`${dateKey || 'default'}-${rowIndex}-${colIndex}`}
                tile={tile}
                isActive={
                  cursor.row === rowIndex &&
                  cursor.col === colIndex
                }
                revealDelay={
                  rowIndex < cursor.row
                    ? colIndex * 0.15
                    : 0
                }
                dateKey={dateKey}
                cellIndex={colIndex}
              />
            ))}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
